import { render } from "./AtletiDetail.vue?vue&type=template&id=7551dfb0"
import script from "./AtletiDetail.vue?vue&type=script&lang=js"
export * from "./AtletiDetail.vue?vue&type=script&lang=js"

import "./AtletiDetail.vue?vue&type=style&index=0&id=7551dfb0&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__